import type { HexRenderContext } from './hexRenderTypes';
import { BaseHex } from './BaseHex';
import { SettlementHex } from './SettlementHex';
import { UnknownHex } from './UnknownHex';

const baseHex = new BaseHex();
const settlementHex = new SettlementHex();
const unknownHex = new UnknownHex();

export function renderHex(context: HexRenderContext): void {
    if (!context.state.discoveredTileIds.has(context.tile.id)) {
        unknownHex.render(context);
        return;
    }
    if (context.settlement) {
        settlementHex.render(context);
    } else {
        baseHex.render(context);
    }
}
